import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Localizable, localizeField } from './localize-field';

@Pipe({
  name: 'localizeField',
  pure: false,
  standalone: false,
})
export class LocalizeFieldPipe implements PipeTransform {
  constructor(private readonly _translocoService: TranslocoService) {}

  transform<T extends Localizable, K extends keyof T & string>(
    node: T | undefined | null,
    field: K,
  ): T[K] | undefined {
    const value = localizeField(node, field, this._translocoService.getActiveLang());
    // If the value is a Transloco key (e.g. "wizard.nav.myInfo"), resolve it.
    // Otherwise return the display string as-is (no missing-key warning).
    if (typeof value === 'string') {
      const lang = this._translocoService.getActiveLang();
      const translations = this._translocoService.getTranslation(lang);
      if (translations && (translations as Record<string, string>)[value] !== undefined) {
        return this._translocoService.translate(value) as unknown as T[K];
      }
    }
    return value;
  }
}
